import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, SpaceBetween } from "@cloudscape-design/components";
import "./NoPermission.css";

const NoPermission: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="no-permission">
      <SpaceBetween size="l" direction="vertical" alignItems="center">
        <div className="no-permission__title">No Permission</div>
        <Box textAlign="center" color="text-body-secondary" fontSize="body-m">
          You don't have permission to access this page. Please contact an administrator below to request access.
        </Box>
        <div className="no-permission__contacts">
          <Box variant="h4" margin={{ bottom: "xs" }}>
            Admin Contacts
          </Box>
          <div className="no-permission__contacts-grid">
            {[
              { group: "North Ops", logins: ["mkzhao"] },
              { group: "South Ops", logins: ["cicixie", "yijianh"] },
              { group: "RBKS", logins: ["wupng"] },
              { group: "System admin", logins: ["sujiache", "psyajing", "mkzhao"] },
            ].map(({ group, logins }) => (
              <React.Fragment key={group}>
                <span className="no-permission__group">{group} -</span>
                <span className="no-permission__logins">
                  {logins.map((login, i) => (
                    <span key={login}>
                      {i > 0 && " / "}
                      <a
                        href={`https://phonetool.amazon.com/users/${login}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="no-permission__link"
                      >
                        @{login}
                      </a>
                    </span>
                  ))}
                </span>
              </React.Fragment>
            ))}
          </div>
        </div>
        <Button variant="primary" onClick={() => navigate("/")}>
          Back to Home
        </Button>
      </SpaceBetween>
    </div>
  );
};

export default NoPermission;
